import { jwtDecode } from 'jwt-decode';

const USER_INFO_KEY = 'user_info';

const TokenService = {
    setUserInfo(token) {
        try {
            const decoded = jwtDecode(token);
            const info = {
                user_id: decoded.user_id,
                role: decoded.role,
                name: decoded.name ?? null,
                company_name: decoded.company_name ?? null,
                exp: decoded.exp,
            };
            localStorage.setItem(USER_INFO_KEY, JSON.stringify(info));
        } catch {
            // ignore malformed token
        }
    },

    clearUserInfo() {
        localStorage.removeItem(USER_INFO_KEY);
    },

    _getInfo() {
        try {
            return JSON.parse(localStorage.getItem(USER_INFO_KEY));
        } catch {
            // missing/corrupted localStorage entry = no user info
            return null;
        }
    },

    getUserId() {
        return this._getInfo()?.user_id ?? null;
    },

    getRole() {
        return this._getInfo()?.role ?? null;
    },

    getName() {
        return this._getInfo()?.name ?? null;
    },

    getCompanyName() {
        return this._getInfo()?.company_name ?? null;
    },

    isExpired() {
        const info = this._getInfo();
        if (!info?.exp) return true;
        return info.exp * 1000 < Date.now();
    },
};

export default TokenService;
